export var KudosType = /*#__PURE__*/function (KudosType) {
  KudosType["INDIVIDUAL"] = "individual";
  KudosType["TEAM"] = "team";
  KudosType["MIXED"] = "mixed";
  return KudosType;
}({});
export var FlagEventType = /*#__PURE__*/function (FlagEventType) {
  FlagEventType["KUDOS_CREATED"] = "kudos-created";
  FlagEventType["KUDOS_FAILED"] = "kudos-failed";
  FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
  FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
  FlagEventType["DIRTY"] = "dirty";
  FlagEventType["CLOSE"] = "close";
  return FlagEventType;
}({});
export var isFlagEventTypeValue = function isFlagEventTypeValue(value) {
  return Object.values(FlagEventType).includes(value);
};

// The kudos user picker can be prepopulated with
// contributors from a project or
// members of contributing teams from a goal